import { ServiceType } from '@/classes/service/AbstractデータService';
import 保有不動産Service, { 合計不動産価格 } from '@/classes/service/分析/保有不動産Service';

export const 個人固定価格種類Keys = ['評価額'] as const;

export default class 個人保有不動産Service extends 保有不動産Service {
  protected serviceType = ServiceType.個人保有不動産;

  // ------------------------------------------------------------------
  // getter/setter
  // ------------------------------------------------------------------

  /**
   * @returns
   */
  public get get計算価格種類Keys(): readonly (keyof 合計不動産価格)[] {
    return 個人固定価格種類Keys;
  }
}
